import { useMocks } from '../../shared/env';
import type { ContractorPaymentRecordsGateway } from './ContractorPaymentRecordsGateway';
import { HttpContractorPaymentRecordsGateway } from './HttpContractorPaymentRecordsGateway';
import { MockContractorPaymentRecordsGateway } from './MockContractorPaymentRecordsGateway';

export const contractorPaymentRecordsGateway: ContractorPaymentRecordsGateway = useMocks
  ? new MockContractorPaymentRecordsGateway()
  : new HttpContractorPaymentRecordsGateway();
export type { ContractorPaymentRecordsGateway } from './ContractorPaymentRecordsGateway';
export * from './types';
